import { useState } from "react";
import ModalStateDialogComponent from "../../cubeComponent/html/modal/ModalWithState";
import ShimmerProfile from "./ShimmerProfile";
import { useSelector } from "react-redux";
import { createPortal } from "react-dom";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";

const UserProfileModal = ({ userId, onClose }) => {
  const [isLoading] = useState(false);
  const usersData = useSelector((state) => state.userTagData);
  const userData = usersData[userId];
  const [selectedUserDataForProfile] = useState(userData.data);

  const userProfileModalHeader = () => <div className="flex w-full justify-end cursor-pointer"></div>;

  const getUserAvatarComponent = (user) => {
    return <UserNameTagComponent showAvatarOnly size="XL" id={user._id} />;
  };

  const userProfileModalContent = () => (
    <div className="items-center flex flex-col gap-[var(--size-8)]">
      {isLoading ? (
        <ShimmerProfile />
      ) : (
        <>
          {getUserAvatarComponent(selectedUserDataForProfile)}
          <div className="text-[16px] text-gray-800 font-semibold">{selectedUserDataForProfile.fullName}</div>
          {selectedUserDataForProfile.designation && (
            <div className="text-[14px] text-gray-800">{selectedUserDataForProfile.designation}</div>
          )}
          {selectedUserDataForProfile.companyName && (
            <div className="text-[14px] text-gray-800">{selectedUserDataForProfile.companyName}</div>
          )}
          <div className="text-[14px] text-gray-800">{selectedUserDataForProfile.email}</div>
        </>
      )}
    </div>
  );

  return createPortal(
    <>
      {(selectedUserDataForProfile || isLoading) && (
        <ModalStateDialogComponent
          width="250"
          isVisible={!!selectedUserDataForProfile || isLoading}
          headerTitle={userProfileModalHeader()}
          modelContent={userProfileModalContent()}
          onCancel={onClose}
        />
      )}
    </>,
    document.getElementById("root"),
  );
};
export default UserProfileModal;
